import { useEffect } from "react";

export const useSetBodyBackgroundColor = (color, isApplyColor) => {
    useEffect(() => {
        if (isApplyColor) {
            const initialColor = document.body.style.backgroundColor;
            document.body.style.backgroundColor = color;
            return () => {
                document.body.style.backgroundColor = initialColor;
            }
        }
    }, [isApplyColor, color])
}